import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

export const DrawerHeaderStyled = styled(Box, { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  paddingLeft: theme.spacing(open ? 3 : 0),
}));

export const DrawerHeaderTitle = styled(Box)(({ theme, isPermanent }) => ({
  height: theme.spacing(8),
  backgroundColor: isPermanent ? '#EDECF5' : '#322E59',
  padding: `0 ${theme.spacing(2.5)}`,
  display: 'flex',
  alignItems: 'center',
}));

